import LoginEntryBase from '#BASE/components/downLoad/loginEntryDownload';

export default {
    mixins: [LoginEntryBase],
    data: function () {
        return {
            btnStyleConf: {
                [true]: "btn cancel",
                [false]: "btn closed",
            },
            checkSettingComplete: true,
            InitLockTime: 3,
            isNotShowToday: false,
        };
    },
}